function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRpdshThck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "45.132 24.902 294.785 277.315",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "stroke",
      fill: "rgba(216, 216, 216, 0)",
      stroke: "rgb(100,100,100)",
      strokeWidth: 8
    },
    d: "M 113.03 238.314 L 235.774 39.158 L 236.579 103.511 L 329.592 147.065 L 236.925 182.104 L 234.434 295.42 L 113.067 238.578 L 113.03 238.314 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(100,100,100)",
      fill: "rgba(216, 216, 216, 0)",
      strokeWidth: 8
    },
    d: "M 126.019 216.222 L 112.03 203.248 L 162.338 180.885 L 143.733 166.114 L 205.421 122.622 L 145.826 94.451 L 53.706 243.75 L 126.019 216.222 Z",
    transform: "matrix(-1, 0, 0, -1, 258.6669921875, 332.816994190216)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(100,100,100)",
      fill: "rgb(100,100,100)",
      strokeWidth: 8
    },
    cx: 233.272,
    cy: 129.631,
    rx: 5.223,
    ry: 5.171
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      whiteSpace: "pre",
      fill: "rgb(51, 51, 51)",
      fontFamily: "Arial, sans-serif",
      fontSize: "12.7px"
    },
    x: 158.875,
    y: 300.152
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpdshThck);
export default __webpack_public_path__ + "static/media/rpdsh-thck.0c83db74c97ddf73c96cf06fa6aa75ce.svg";
export { ForwardRef as ReactComponent };